<template>
    <section :class="[
        'tw-rounded-2xl tw-p-6 tw-shadow-2xl',
        theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'
    ]">
        <div class="tw-flex tw-items-center tw-gap-3 tw-mb-6">
            <div class="tw-p-2.5 tw-rounded-xl" :class="theme === 'dark' ? 'tw-bg-emerald-500/10 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-text-emerald-600'">
                <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"/></svg>
            </div>
            <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Configuração de Aeração</h3>
        </div>

        <div class="tw-space-y-6">
            <!-- Programa Selection -->
            <div>
                <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-block tw-mb-3">Selecione o Programa</label>
                <div class="tw-grid xs:tw-grid-cols-2 sm:tw-grid-cols-3 tw-gap-2">
                    <label v-for="programa in programas" :key="programa.id" class="tw-flex tw-items-center tw-cursor-pointer">
                        <input :disabled="!permissaoEditar" type="radio" class="tw-sr-only tw-peer" name="programa" v-model="selectedProgramaId" :value="programa.id">
                        <div :class="[
                            selectedProgramaId === programa.id 
                                ? (theme === 'dark' ? 'tw-bg-emerald-500/10 tw-border-emerald-500 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-border-emerald-500 tw-text-emerald-600')
                                : (theme === 'dark' ? 'tw-bg-slate-800 tw-border-slate-700 tw-text-slate-400' : 'tw-bg-gray-100 tw-border-gray-200 tw-text-gray-600'),
                            'tw-flex-1 tw-px-3 tw-py-2 tw-rounded-lg tw-text-xs tw-font-semibold tw-border'
                        ]">
                            {{ programa.descricao }}
                        </div>
                    </label>
                </div>
            </div>

            <hr :class="theme === 'dark' ? 'tw-border-slate-800' : 'tw-border-gray-200'" />

            <!-- Modo de Operação -->
            <div>
                <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-block tw-mb-3">Modo de Operação</label>
                <div class="tw-grid tw-grid-cols-2 tw-gap-2">
                    <label v-for="modo_operacao in modos_operacao" :key="modo_operacao.value" class="tw-flex tw-items-center tw-cursor-pointer">
                        <input :disabled="!permissaoEditar" type="radio" class="tw-sr-only tw-peer" name="modo_operacao" v-model="selectedModoAeracao" :value="modo_operacao.value">
                        <div :class="[
                            selectedModoAeracao === modo_operacao.value
                                ? (theme === 'dark' ? 'tw-bg-blue-500/10 tw-border-blue-500 tw-text-blue-400' : 'tw-bg-blue-50 tw-border-blue-500 tw-text-blue-600')
                                : (theme === 'dark' ? 'tw-bg-slate-800 tw-border-slate-700 tw-text-slate-400' : 'tw-bg-gray-100 tw-border-gray-200 tw-text-gray-600'),
                            'tw-flex-1 tw-px-3 tw-py-2 tw-rounded-lg tw-text-xs tw-font-semibold tw-border'
                        ]">
                            {{ modo_operacao.descricao }}
                        </div>
                    </label>
                </div>
            </div>

            <!-- Status de Aeração -->
            <div>
                <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-block tw-mb-3">Status de Aeração</label>
                <div class="tw-grid tw-grid-cols-2 tw-gap-2">
                    <label v-for="aeracao in aeracao_status" :key="aeracao.value" class="tw-flex tw-items-center tw-cursor-pointer">
                        <input :disabled="!permissaoEditar" type="radio" class="tw-sr-only tw-peer" v-model="selectedAeracaoStatus" :value="aeracao.value">
                        <div :class="[
                            selectedAeracaoStatus === aeracao.value
                                ? (aeracao.value === 0 ? (theme === 'dark' ? 'tw-bg-emerald-500/10 tw-border-emerald-500 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-border-emerald-500 tw-text-emerald-600') : (theme === 'dark' ? 'tw-bg-red-500/10 tw-border-red-500 tw-text-red-400' : 'tw-bg-red-50 tw-border-red-500 tw-text-red-600'))
                                : (theme === 'dark' ? 'tw-bg-slate-800 tw-border-slate-700 tw-text-slate-400' : 'tw-bg-gray-100 tw-border-gray-200 tw-text-gray-600'),
                            'tw-flex-1 tw-px-3 tw-py-2 tw-rounded-lg tw-text-xs tw-font-semibold tw-border'
                        ]">
                            {{ aeracao.descricao }}
                        </div>
                    </label>
                </div>
            </div>

            <hr :class="theme === 'dark' ? 'tw-border-slate-800' : 'tw-border-gray-200'" />

            <!-- Seleção de Produto -->
            <div>
                <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Produto</label>
                <div class="tw-mt-2">
                    <BaseSelect :disabled="!permissaoEditar" v-model="selectedProdutoId" :options="produtos" option-label="descricao" option-value="id" placeholder="Selecione o produto" searchable />
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import BaseSelect from '@/components/ui/v2/BaseSelect.vue';

export default {
    components: { BaseSelect },
    props: {
        programa: {
            type: Object,
            default: () => ({})
        },
        modo_operacao: {
            type: Number,
            default: () => (null)
        },
        aeracao: {
            type: Number,
            default: () => (null)
        },
        produto: {
            type: Object,
            default: () => ({})
        },
        permissaoEditar: {
            type: Boolean,
            required: true
        },
        theme: {
            type: String,
            default: 'light'
        }
    },
    data() {
        return {
            produtos: [
                {"descricao": "Vazio", "id": 1},
                {"descricao": "Cevada", "id": 2},
                {"descricao": "Feijão", "id": 3},
                {"descricao": "Milho", "id": 4},
                {"descricao": "Arroz", "id": 5},
                {"descricao": "Sorgo", "id": 6},
                {"descricao": "Soja", "id": 7},
                {"descricao": "Trigo", "id": 8},
                {"descricao": "Canola", "id": 9},
                {"descricao": "Azevém", "id": 10},
                {"descricao": "Linhaça", "id": 11},
                {"descricao": "Painço", "id": 12},
                {"descricao": "Alpiste", "id": 13},
                {"descricao": "Milheto", "id": 14},
                {"descricao": "Aveia", "id": 15},
                {"descricao": "Girassol", "id": 16},
                {"descricao": "Outro", "id": 17}
            ],
            programas: [
                {"descricao": "Programa Livre", "id": 1},
                {"descricao": "Programa Livre Temporizado", "id": 2},
                {"descricao": "Equilíbrio Higroscópico", "id": 3},
                {"descricao": "Programa Curva 1", "id": 4},
                {"descricao": "Programa Curva 2", "id": 5},
                {"descricao": "Programa Curva 3", "id": 6},
                {"descricao": "Programa Curva 4", "id": 7},
                {"descricao": "Programa Personalizado", "id": 8},
            ],
            modos_operacao: [
                {"descricao": "Automatico", "value": 1},
                {"descricao": "Manual", "value": 0}
            ],
            aeracao_status: [
                {"descricao": "Liberado", "value": 0},
                {"descricao": "Bloqueado", "value": 1},

            ],
            selectedProdutoId: null,
            selectedProgramaId: null,
            selectedModoAeracao: null,
            selectedAeracaoStatus: null
        }
    },
    watch: {
        produto: {
            immediate: true,
            handler(newProduto) {
                if (newProduto && newProduto.id) {
                    this.selectedProdutoId = newProduto.id;
                }
            }
        },
        programa: {
            immediate: true,
            handler(newPrograma) {
                if (newPrograma && newPrograma.id) {
                    this.selectedProgramaId = newPrograma.id;
                }
            }
        },
        modo_operacao: {
            immediate: true,
            handler(newModo_operacao) {
                if (newModo_operacao == 0 || newModo_operacao == 1) {
                    this.selectedModoAeracao = newModo_operacao
                }
            }
        },
        aeracao: {
            immediate: true,
            handler(newAeracao) {
                if (newAeracao == 0 || newAeracao == 1) {
                    this.selectedAeracaoStatus = newAeracao
                }
            }
        }
    },
    methods: {
        getAeracaoAcoes() {
            return {
                "programa": this.selectedProgramaId,
                "produto": this.selectedProdutoId,
                "modo_operacao": this.selectedModoAeracao,
                "aeracao": this.selectedAeracaoStatus
            }
        }
    }
}
</script>